// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from "vuex"
import App from './App'
import router from './router'
/**引入加载进度条 */
import NProgress from "nprogress"
import "nprogress/nprogress.css"  // 这个样式必须引入
/**引入elementUI */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
/**引入vuex */
import store from './store'
/**引入请求实例 */
import http from './plugins/http';
/**使用彩色图标 */
import '@/style/fonts/iconfont.js';
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(http);
/**进度条配置 */
NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false
});
//初始化 租户id
store.dispatch("setTenantId").then(res=>{
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    })
}).catch(err=>{
  console.error("解析子域名失败,进入默认租户");
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
})




// WEBPACK FOOTER //
// ./src/main.js